import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa',
      type: 'string',
      fieldRequired: true
    },
    type: {
      title: 'Typ',
      type: 'string',
      fieldRequired: true
    },
    moduleId: {
      title: 'Moduł',
      type: 'number',
      fieldRequired: false
    },
    eventIds: {
      title: 'Zdarzenia',
      type: 'string',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
